export const CourtModuleType = {
  AragonCourt: Symbol('COURT_MAIN_MODULE'),
  DisputeManager: Symbol('COURT_MODULE_DISPUTE_MANAGER'),
  GuardiansRegistry: Symbol('COURT_MODULE_GUARDIANS_REGISTRY'),
  Voting: Symbol('COURT_MODULE_VOTING'),
  Treasury: Symbol('COURT_MODULE_TREASURY'),
  Subscriptions: Symbol('COURT_MODULE_SUBSCRIPTIONS'),
}